import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import endpoint from 'shared/api';

interface GetSeedPayload {
  id?: string;
  answersUri: string;
  verticalId: string;
  affiliateId: string;
  affiliateSource?: string;
  path: string;
  variant?: string;
  email?: string;
}

const getSeedId = (data: GetSeedPayload) => {
  return endpoint.network.post<GetSeedPayload>('/signups/seeds', data);
};

export const useGetSeedId = () => {
  const onGetSeedId = ({
    verticalId,
    affiliateId,
    affiliateSource,
    path,
    answersUri,
    variant,
    email,
  }: GetSeedPayload) =>
    getSeedId({
      verticalId,
      affiliateId,
      affiliateSource,
      path,
      answersUri,
      variant,
      email,
    });

  const mutation = useMutation({
    mutationFn: onGetSeedId,
    onError: (error, variables) => {
      const { verticalId, affiliateId, path } = variables;

      Sentry.captureException(error, {
        tags: {
          feature: 'SEED_ID',
        },
        extra: {
          verticalId,
          affiliateId,

          path,
          description: `Error happened while creating a seedId`,
        },
      });
    },
  });

  return mutation;
};
